const HisPlus = ({ color, sx }) => {
  const strokeColor = color ?? "#4C2AC6";
  const _sx = sx ?? {};
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 1V15" stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 8H15" stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default HisPlus;
